export const skillxDepartmentNames = ['SkillX'];
export const FOUNDATION_DEPARTMENT_ID = 3;

export const assignedToDepartment = [
  { id: 11, name: 'Operations Growth Department (OGD)' },
  { id: 28, name: 'Client Service Department' },
];

export const prospect_leads_departments = [
  { id: 28, name: 'CSD' },
  { id: 11, name: 'OGD' },
];
